import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as accessTokenInfo from "./accessToken";

import authInfo from './modules/auth'
import articles from './modules/articles'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loading: false,
        
    },
    getters: {
        /*getAutocompleteList: state => {
            return state.autocomplete.data
        }*/
    },
    mutations: {
        changeLoader: state => {
            state.loading = !state.loading
        },
        setOverlayState: state => {
            state.pageOverlay = true
        },
        unsetOverlayState: state => {
            state.pageOverlay = false
        },
    },
    actions: {
        deleteData: ({commit, dispatch}, payload) => {
            
            //console.log(JSON.stringify(payload))
            axios.post(payload.actionPath, payload.data, accessTokenInfo.accessTokenInfo())
            .then(res => {
               
                commit('unsetOverlayState')

                if(res.data.status) {
                    if(payload.payload != null) {
                        dispatch(payload.listActionName, payload.payload)    
                    } else {
                        dispatch(payload.listActionName)    
                    }
                    
                }

            })
            .catch(error => {
                commit('unsetOverlayState')
                console.log(error)
            })
        
        },
        createOrUpdateData: ({commit, dispatch}, payload) => {
               
               commit('setOverlayState')
            
               let submitPayload = {

                    target: payload.target,
                    targetParameters: payload.targetParameters,
                    admin: 0

               }

               let allowed = true
                
               if(allowed == true) {
                    dispatch(submitPayload.target, submitPayload.targetParameters).then(() => {
                       /* 
                       dispatch('postActivityLog', 
                            {target_page: submitPayload.target, target_data: JSON.stringify(submitPayload.targetParameters)})
                        */
                    })
                    
                } else {
                    commit('unsetOverlayState')
                    commit('setAlertBox', {message: 'message.accessDeniedError'})
                }

                commit('setConfirmBoxOff')
        }
    },
    modules: {
        authInfo, articles
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js